// eslint-disable-next-line
export default 'prod';
